import { CanMatchFn, Route, UrlSegment } from '@angular/router';

interface UrlSegmentWithParams extends UrlSegment {
    path: string;
    id: string;
    regexp: string;
}

const getSegmentsWithParams = (route: Route): UrlSegmentWithParams[] => {
    const placeholder =
        /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
    const routeParam = /^\{(.*)\}$/g;
    const urlSegments = route.data.route.split('/');
    const segmentsWithParams = [];
    urlSegments.forEach((segment) => {
        const match = placeholder.exec(segment.trim());
        placeholder.lastIndex = 0;
        if (match) {
            const param = match[2] || match[3];
            const regexp =
                match[4] || (match[1] === '*' ? '.*' : !match[1] ? '.*' : null);
            if (regexp) {
                const regexpString = regexp.replace(/^\(\?\:|\)$/g, '');
                segmentsWithParams.push({
                    path: segment,
                    id: param,
                    regexp: '^' + regexpString + '$',
                });
            } else {
                segmentsWithParams.push({ path: segment, id: param });
            }
        } else {
            const routeMatch = routeParam.exec(segment);
            if (routeMatch) {
                segmentsWithParams.push({
                    path: segment,
                    id: routeMatch[1],
                    regexp: '.*',
                });
            } else {
                segmentsWithParams.push({ path: segment });
            }
        }
    });
    return segmentsWithParams;
};

export const urlMatcherGuard: CanMatchFn = (
    route: Route,
    segments: UrlSegment[],
): boolean => {
    const segmentsWithParams = getSegmentsWithParams(route);
    const posParams: Record<string, UrlSegment> = {};
    let validSegment = true;

    segmentsWithParams.forEach((param, index) => {
        const parameter = param.id;
        const regex = new RegExp(param.regexp, 'g');

        if (segments.length > 0 && !segments[index]) {
            validSegment = false;
        } else if (segments[index] && regex.test('')) {
            posParams[parameter] = segments[index];
            return true;
        } else if (!segments[index]) {
            validSegment = false;
        } else if (regex.test(segments[index].path)) {
            posParams[parameter] = segments[index];
        } else {
            validSegment = false;
        }
    });

    return validSegment;
};
